<script lang="ts">
  import { onMount } from 'svelte';
  import { unBanUsers } from '../../api/api';
  import { bansSubject$, pollBans } from '../../api/restrictedUsers.api';
  import RestrictedUsers, {
    type RestrictedUser,
  } from './RestrictedUsers.svelte';

  let bans = $state<RestrictedUser[] | null>(null);

  const lift = async (userIds: string[], issuedBy: string) => {
    await unBanUsers({ userIds, issuedBy });
    bansSubject$.next();
  };

  onMount(() => {
    const subscription = pollBans().subscribe({
      next: (data) =>
        (bans = data.map(({ bannedAt, ...ban }) => ({
          ...ban,
          issuedAt: bannedAt,
        }))),
      error: (err) => console.error('Bans subscription error', err),
    });
    return () => subscription.unsubscribe();
  });
</script>

<RestrictedUsers
  users={bans}
  words={{ noun: 'ban', done: 'banned', undo: 'unban', undone: 'unbanned' }}
  {lift}
/>
